const split = (str) => str.split(',').filter((v) => v !== '')

// Used for sorting styles in the Algolia style facet
const STYLE_ORDER = [
  { style: 'solid', order: 1 },
  { style: 'regular', order: 2 },
  { style: 'light', order: 3 },
  { style: 'thin', order: 4 },
  { style: 'duotone', order: 5 } // duotone is required for v5 sorting
]

const DEFAULT_ORDER_RANK = 100

export function queryToParams(query) {
  const { q = '', f = '', s = '', c = '', m = '', o = '', ic = '', ip = '', it = '', new: newInV6 = false, sponsored = false, favorites = null } = query

  let p = parseInt(query.p || 1, 10)

  if (isNaN(p)) {
    p = 1
  }

  let iconPacks = ip
  if (f !== '' && ip === '') {
    iconPacks = f
  }

  return {
    page: p,
    term: q,
    orderBy: o,
    styles: split(s),
    categories: split(c),
    free: m === 'free',
    sponsored: sponsored === 'yes',
    new: newInV6 === 'yes',
    iconCollections: split(ic),
    iconPacks: split(iconPacks),
    iconTypes: split(it),
    favorites
  }
}

const assign = (obj, key, values) => {
  if (Array.isArray(values) && values.length > 0) {
    obj[key] = values.join(',')
  } else if (typeof values === 'string' && values.length > 0) {
    obj[key] = values
  }
}

// WARNING: modifying this without also updating algoliaRouteState.js could create problems! This is used by shortcut for $search
export function paramsToQuery(params) {
  const res = {}

  if (params.page) {
    res.p = params.page.toString()
  }

  const { term, family, styles, categories, free, sponsored, orderBy, new: newInV6, favorites, iconPacks, iconCollections, iconTypes } = params

  assign(res, 'q', term)
  if (free) {
    assign(res, 'm', 'free')
  }
  if (sponsored) {
    assign(res, 'sponsored', 'yes')
  }
  if (newInV6) {
    assign(res, 'new', 'yes')
  }

  if (family) {
    assign(res, 'ip', family)
  } else {
    assign(res, 'ip', iconPacks)
  }

  assign(res, 'favorites', favorites)
  assign(res, 's', styles)
  assign(res, 'c', categories)
  assign(res, 'ic', iconCollections)
  assign(res, 'it', iconTypes)

  if (orderBy == 'a' || Object.keys(res).length > 0) {
    assign(res, 'o', orderBy || 'r')
  }

  return res
}

export function fetchIndexName(currentVersion) {
  if (currentVersion.startsWith('5')) {
    return FONTAWESOME.ALGOLIA_V5_SEARCH_INDEX_NAME
  } else {
    return FONTAWESOME.ALGOLIA_V6_SEARCH_INDEX_NAME
  }
}

// This function is currently only used for Kit Subsetting (Everything else should be using the latest index)
export function fetchIndexNameByVersion(version) {
  if (version.includes('x')) {
    // return latest v5 or v6
    return fetchIndexName(version)
  } else {
    // This should NOT use the collections index UNLESS we build indexes for all older versions
    return `${getEnvironmentPrefix()}fontawesome_com-splayed-${version}`
  }
}

function getEnvironmentPrefix() {
  switch (FONTAWESOME.ALGOLIA_ENVIRONMENT_PREFIX) {
    case 'development':
      return 'dev_'

    case 'staging':
      return 'staging_'

    case 'epic':
      return 'epic_'

    default:
      return ''
  }
}

export function sortStyles(items) {
  items.sort((a, b) => {
    const orderA = STYLE_ORDER.find((s) => s.style === a.label) || { order: DEFAULT_ORDER_RANK }
    const orderB = STYLE_ORDER.find((s) => s.style === b.label) || { order: DEFAULT_ORDER_RANK }

    return orderA.order - orderB.order
  })

  return items
}
